import { useEffect, useRef } from 'react';
import './App.css';

function App() {
  useEffect(() => {
    const securePage = window.location.protocol === 'https:';

    if (!securePage) {
      console.warn('Eventbrite embedded checkout requires HTTPS. The modal may not initialize.');
    }

    const script = document.createElement('script');
    script.src = 'https://www.eventbrite.com/static/widgets/eb_widgets.js';
    script.async = true;

    const createEventbriteWidget = () => {
      if (!window.EBWidgets) {
        return false;
      }

      window.EBWidgets.createWidget({
        widgetType: 'checkout',
        eventId: '1995862485421',
        modal: true,
        modalTriggerElementId: 'eventbrite-widget-modal-trigger-1995862485421',
        onOrderComplete: function() {
          console.log('Order complete!');
        },
      });

      return true;
    };

    const onScriptLoad = () => {
      let attempts = 0;

      const tryInit = () => {
        attempts += 1;
        if (createEventbriteWidget()) {
          return;
        }

        if (attempts < 10) {
          window.setTimeout(tryInit, 250);
        }
      };

      tryInit();
    };

    const onScriptError = () => {
      console.error('Failed to load Eventbrite widget script from', script.src);
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('error', onScriptError);
    document.body.appendChild(script);

    return () => {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('error', onScriptError);
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const eventbriteTriggerRef = useRef(null);

  return (
    <div className="App">
      {/* Navigation Menu */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-logo">
            <a href="#home">THE RED CURTAIN</a>
          </div>
          <ul className="nav-menu">
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#details">Details</a></li>
            <li>
            <button
              type="button"
              className="cta-button"
              onClick={() => eventbriteTriggerRef.current?.click()}
            >
              Get Tickets
            </button>
          </li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero" id="home">
        <div className="hero-content">
          <div className="hero-subtitle">BISCUIT & BLUES PRESENTS</div>
          <img src="/RedCurtainLogo.png" alt="The Red Curtain Logo" className="hero-logo" />
          <button
            type="button"
            className="cta-button"
            onClick={() => eventbriteTriggerRef.current?.click()}
          >
            Get Tickets
          </button>
        </div>
      </section>

      {/* What's Happening Section */}
      <section className="whats-happening" id="about">
        <div className="container">
          <h2>What's Happening</h2>
          <p className="section-description">
            An electric night of comedy and live music at Biscuits & Blues. Experience top comedians performing alongside live bands in San Francisco's most sophisticated nightclubs.
          </p>
          <div className="highlights">
            <div className="highlight-card">
              <div className="highlight-icon">🎤</div>
              <h3>Top Comics</h3>
              <p>New Lineup of Killer Comedians Every Week</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">🎸</div>
              <h3>Live Music</h3>
              <p>Before, During, and After the Show</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">🍹</div>
              <h3>Craft Cocktails</h3>
              <p>Food, Drinks, & Good Vibes</p>
            </div>
          </div>
        </div>
      </section>

      {/* Atmosphere Section */}
      <section className="atmosphere" id="experience">
        <div className="container">
          <h2>The Experience</h2>
          <p className="section-description">
            Intimate room. Big laughs. Great night. Candlelit tables, premium craft cocktails, and performances from top comedians and musicians create an unforgettable evening.
          </p>
          <div className="atmosphere-grid">
            <div className="atmosphere-item">
              <img src="/CrowdPhotoLaughing2.jpeg" alt="Venue atmosphere at Biscuit & Blues" className="placeholder-image" />
              <p>Intimate seating with hilarious atmosphere</p>
            </div>
            <div className="atmosphere-item">
              <img src="/DennisJones.jpg" alt="Comedian performing on stage" className="placeholder-image" />
              <p>Live entertainment on stage</p>
            </div>
            <div className="atmosphere-item">
              <img src="/CrowdPhotoLaughing1.jpg" alt="Crowd enjoying the show" className="placeholder-image" />
              <p>Sophisticated audience experience</p>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Section */}
      <section className="event-details" id="details">
        <div className="container">
          <h2>Event Details</h2>
          <div className="details-grid">
            <div className="detail-box">
              <h3>When</h3>
              <p>Monthly show<br />Dates vary throughout the year</p>
            </div>
            <div className="detail-box">
              <h3>Where</h3>
              <p>Biscuit & Blues<br />401 Mason St<br />San Francisco, CA</p>
            </div>
            <div className="detail-box">
              <h3>What to Expect</h3>
              <p>Comedy performances<br />Live music<br />Craft cocktails<br />Unforgettable night</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-final" id="tickets">
        <div className="container">
          <h2>Ready for a Great Night?</h2>
          <button
            id="eventbrite-widget-modal-trigger-1995862485421"
            type="button"
            className="cta-button cta-button-large"
            ref={eventbriteTriggerRef}
          >
            Get Tickets
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>Biscuit & Blues | 401 Mason St, San Francisco, CA</p>
        </div>
      </footer>
    </div>
  );
}

export default App;